import React from 'react';

export default function CheckRedIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '24'}
      height={props.height ?? '24'}
      {...props}
    >
      <rect
        width="24"
        height="24"
        rx="12"
        fill={props.fill ?? '#DC4405'}
        fillOpacity="0.15"
      />
      <path
        d="M7.33203 11.4414L11.032 15.1414L17.316 8.85742"
        stroke={props.stroke ?? '#DC4405'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
